import React from 'react';

const VARIANTS = {
  default:   { bg: 'var(--bg-input)',          text: 'var(--text-body)',        border: 'var(--border-subtle)' },
  primary:   { bg: 'rgba(63,239,166,0.1)',     text: 'var(--accent)',           border: 'rgba(63,239,166,0.3)' },
  secondary: { bg: 'var(--bg-surface)',        text: 'var(--text-muted)',       border: 'var(--border-subtle)' },
  success:   { bg: 'rgba(63,239,166,0.1)',     text: 'var(--accent)',           border: 'rgba(63,239,166,0.3)' },
  warning:   { bg: 'rgba(234,179,8,0.1)',      text: '#ca8a04',                 border: 'rgba(234,179,8,0.3)'  },
  danger:    { bg: 'rgba(239,68,68,0.1)',      text: '#dc2626',                 border: 'rgba(239,68,68,0.25)' },
};

const Pill = ({ children, variant = 'default', className = '', onClick, ...props }) => {
  const v = VARIANTS[variant] || VARIANTS.default;

  return (
    <span
      onClick={onClick}
      className={`pill ${className}`}
      style={{
        background: v.bg,
        color:      v.text,
        border:     `1px solid ${v.border}`,
        cursor:     onClick ? 'pointer' : 'default',
      }}
      {...props}
    >
      {children}
    </span>
  );
};

export default Pill;
